module.exports = __webpack_public_path__ + "static/littleWomen3s-2050dd82a4f4027b7c6e8d3b793e4188.jpg";